import { Navigate, useParams } from 'react-router-dom';

/**
 * Keeps links to the Tenant Config pages that moved when the workspace was
 * regrouped (numeration schemas, status transition actions, client portal)
 * working, forwarding a detail route to the same record's new address.
 */
export const LegacyTenantRedirect = ({ to }: { to: string }) => {
  const { id } = useParams<{ id: string }>();

  return <Navigate to={id ? `${to}/${id}` : to} replace />;
};
